import UniDataTools from '@/common/classes/UniDataTools'
import DateHelper from './evals/date-helper'
import FileHelper from './evals/file-helper'
import Messages from './evals/messages'
import ProgressBar from './evals/progressBar'
import { localPropertiesService } from '@/services/local-properties/local-properties.service'
import { MainFrame } from '@/services/main-frame/mainFrame.service'

/**
 * Пакеты функций для EN (Execution Node)
 */
export const Packages = {
  ru: {
    esoft: {
      wf: {
        client: {
          constants: {
            LocalProperties: localPropertiesService.getApi(),
          },
        },
      },
      fatclient: {
        tools: {
          Messages,
          ProgressBar,
          Dates: {
            addMinutes: (target: any, count: number) => {
              console.warn("addMinutes is not implemented", { target, count })
            },
          },
        },
      },
      swingfatclient: {
        frames: {
          MainFrame,
        },
        swinglogic: {
          SwingTreeTable: function SwingTreeTable() {},
        },
      },
      tools: {
        DateHelper,
        FileHelper,
      },
      Platform: {
        util: {
          tools: {
            UniDataTools,
          },
        },
      },
    },
  },
  /** Заглушки java.* для isInstanceOf и таймеров (java.util.Date в onLoad/listener) */
  java: {
    lang: {
      Iterable: Object.freeze({ __platformIterableMarker: true }),
    },
    util: {
      Date,
    },
  },

  javax: {
    swing: {
      /**
       * В толстом клиенте должен возвращать иконку,
       * тут просто возвращает какой-то объект
       */
      ImageIcon: function (imageRes: string) {
        return { url: imageRes }
      },
    },
  },
  // Helper function for async operations with progress bars
  // Usage: setTimeoutAsync(callback, delay)
  setTimeoutAsync: (callback: () => void, delay: number): Promise<void> => {
    return new Promise(resolve => {
      setTimeout(() => {
        callback()
        resolve()
      }, delay)
    })
  },

  // Helper function to run async loop with delay
  // Usage: asyncLoop(count, callback, delay)
  asyncLoop: async (count: number, callback: (i: number) => void, delay: number = 1000): Promise<void> => {
    for (let i = 0; i < count; i++) {
      callback(i)
      if (i < count - 1) {
        await new Promise(resolve => setTimeout(resolve, delay))
      }
    }
  },

}

export default Packages
